import React from 'react'

import GalleryLoader from '../GalleryLoader'
import GalleryItem from '../GalleryItem'
import GalleryNoItems from '../GalleryNoItems'
import './styles.scss'

const bc = 'gallery-items'

const GalleryItems = ({
  pending,
  images,
  selectImage,
  setCropperImage,
  currentImage,
  innerModifier,
  showModal,
  minImageWidth,
  minImageHeight,
  getImage = image => (image.toJS ? image.toJS() : image),
  getKey = image => (image.get ? image.get('id') : image.id),
  getCaption,
  isSkipCropper,
}) => {
  return (
    <div className={`${bc} ${bc}--${innerModifier}`}>
      {pending ? (
        <GalleryLoader />
      ) : images.size !== 0 ? (
        images.map(image => {
          return (
            <GalleryItem
              key={getKey(image)}
              image={getImage(image)}
              currentImage={currentImage}
              onItemClick={(image, width, height) => {
                setCropperImage(image)
                if ((width === minImageWidth && height === minImageHeight) || isSkipCropper) {
                  selectImage({ ...image, width, height })
                } else {
                  showModal(image)
                }
              }}
              minImageWidth={minImageWidth}
              minImageHeight={minImageHeight}
              caption={getCaption && getCaption(image)}
              innerModifier={innerModifier}
            />
          )
        })
      ) : (
        <GalleryNoItems />
      )}
    </div>
  )
}

export default GalleryItems
